<div class="header-container">
  <!-- 
  We set the headerText as innerHTML so that others can insert tags to break lines
  See quick checkout component select-new-time state 
  -->
  <h3 class="calendar-header" data-test="book-a-session" [innerHTML]="headerText"></h3>
</div>


<div class="timezone text-timezone" data-test="timezone">
  <p>{{ browserTimeZone | providerTimeZoneString }} timezone displayed</p>
</div>

@if (!hasNoTimesForSessionType) {
  <appointment-carousel
    [appointmentSlots]="visibleAppointmentSlots"
    (appointmentSlotSelectionChanged)="handleAppointmentSlotSelectionChanged($event)"
    (exitFocusFromCalendarEvent)="handleExitCalendarFocus()"
  >
  </appointment-carousel>
}

@if (hasNoTimesForSessionType) {
  <p class="no-times" data-test="no-times-for-session-type">
    {{ noTimesForSessionTypeMessage }}
  </p>
}

@if (showSessionType) {
  <hr class="session-type-divider">
  <iris-card class="session-type" data-test="session-type">
    <ng-template [ngTemplateOutlet]="sessionPreferences" />
  </iris-card>

  <div class="mobile-session-type">
    <ng-template [ngTemplateOutlet]="sessionPreferences" />
  </div>
}

<iris-card-footer class="footer-button" [ngClass]="{'in-modal': isInModal}">  
  <hr class="footer-divider">
  @if (!hasSelectedTimeslot) {
    <div class="text-center">
      <p>Not ready to schedule just yet?</p>
    </div>
  }
  <div class="button-container">
    <iris-button
      id="book-calendar-slot-button"
      class="submit-button"
      [buttonType]="irisButtonTypes.PRIMARY"
      data-test="book-session-button"
      (click)="onSubmit()"
    >
      {{ submitButtonText }}
    </iris-button>
  </div>
</iris-card-footer>

<ng-template #sessionPreferences>
  @if (isInModal) {
    <form [formGroup]="providerCalendarFormGroupInModal">
      <iris-radio-group
        id="session-type-radio-group"
        [options]="sessionTypeOptions"
        formControlName="sessionTypePreferenceFromModal"
        aria-label="Session location preference"
      />
    </form>
  } @else {
    <form [formGroup]="providerCalendarFormGroup">
      <iris-radio-group
        id="session-type-radio-group"
        [options]="sessionTypeOptions"
        formControlName="sessionTypePreference"
        aria-label="Session location preference"
      />
    </form>
  }
</ng-template>